export default __webpack_public_path__ + "static/media/icon-draper.174eb029.svg";